// Campos do laudo de calibracao de MANOMETRO.
// Os campos aqui sao exatamente os que o laudo atual imprime.
const manometro = {
  titulo: 'Manômetro / Manovacuômetro / Transdutor',
  leituras: 'carga',
  maxPontos: 5,
  secoes: [
    {
      titulo: 'Identificação do instrumento',
      campos: [
        { n: 'subtipo', l: 'Equipamento', t: 'sel', span: 5, ajuda: 'Define o nome que sai no título e no bloco do laudo. Os três usam o mesmo formulário.',
          o: [['manometro', 'Manômetro'], ['manovacuometro', 'Manovacuômetro'], ['transdutor', 'Transdutor de Pressão']] },
        { n: 'tag', l: 'TAG', t: 'texto', span: 4, up: true, ajuda: 'Identificação do instrumento dentro do cliente. Ex.: MA-01.' },
        { n: 'marca', l: 'Marca', t: 'texto', span: 5, ajuda: 'Fabricante gravado no instrumento. Em branco sai NÃO CONSTA no laudo.' },
        { n: 'tipo_instrumento', l: 'Tipo', t: 'sel', span: 5, ajuda: 'Como o manômetro indica a pressão. Em branco o laudo assume ANALÓGICO.',
          o: [['analogico', 'Analógico'], ['digital', 'Digital']] },
        { n: 'classe', l: 'Classe', t: 'texto', span: 5, ajuda: 'Classe de exatidão informada pelo fabricante. Sem essa informação na placa, deixe vazio.' },
        { n: 'conexao', l: 'Conexão', t: 'sel', span: 5, ajuda: 'Bitola da rosca de ligação, igual à lista do laudo de inspeção.',
          o: [['1/4', '1/4"'], ['1/2', '1/2"'], ['3/4', '3/4"'], ['outra', 'Outra']] },
        { n: 'local_instalacao', l: 'Local de instalação', t: 'texto', span: 6, up: true, ajuda: 'Onde o manômetro está instalado. Normalmente a TAG do vaso. É essa pasta que recebe o PDF no portal.' },
        { n: 'unidade', l: 'Unidade', t: 'sel', span: 4, ajuda: 'Unidade de pressão das leituras.',
          o: [['kgf', 'kgf/cm²'], ['bar', 'bar'], ['psi', 'psi'], ['mpa', 'MPa']] },
        { n: 'escala_min', l: 'Escala mín.', t: 'num', span: 4, ajuda: 'Menor valor da escala do manômetro. Normalmente 0.' },
        { n: 'escala_max', l: 'Escala máx.', t: 'num', span: 4, ajuda: 'Maior valor da escala do manômetro, o fim do mostrador.' },
        { n: 'resolucao', l: 'Resolução', t: 'num', span: 4, ajuda: 'Menor divisão que o manômetro mostra. Ex.: 0,5 para um mostrador marcado de 0,5 em 0,5.' },
        { n: 'validade_anos', l: 'Validade', t: 'sel', span: 3, ajuda: 'De quanto em quanto tempo o manômetro deve ser recalibrado.',
          o: [[1, '1 ano'], [2, '2 anos'], [3, '3 anos'], [4, '4 anos'], [5, '5 anos']] },
        { n: 'data_calibracao', l: 'Data', t: 'data', span: 3, ajuda: 'Data em que a calibração foi executada.' }
      ]
    }
  ],
  pontos: {
    ajuda: 'V.M é a pressão indicada pelo padrão no ponto. VVC é o que o manômetro mostrou, subindo (carregamento) e descendo (descarregamento). O laudo imprime até 5 pontos.',
    colunas: [
      { n: 'vm', l: 'V.M — valor do padrão', ajuda: 'Pressão de referência do ponto, lida no manômetro padrão.' },
      { n: 'carga', l: 'VVC carregamento', ajuda: 'Leitura do manômetro com a pressão subindo.' },
      { n: 'desc', l: 'VVC descarregamento', ajuda: 'Leitura do manômetro com a pressão descendo.' }
    ]
  },
  fechamento: [
    { n: 'resultado_laudo', l: 'Resultado', t: 'sel', span: 5, o: [['APROVADO', 'Aprovado'], ['REPROVADO', 'Reprovado']],
      ajuda: 'O que sai no laudo. A sugestão abaixo segue as regras: danificado e não substituído reprova; com classe e escala preenchidas, compara o maior erro com a tolerância da classe.',
      sugestao: (v) => {
        if (v.danificado && !v.substituido) return 'REPROVADO';
        const cls = parseFloat(String(v.classe || '').replace(',', '.'));
        const mi = v.escala_min, ma2 = v.escala_max;
        let maior = null;
        (Array.isArray(v.pontos) ? v.pontos : []).forEach((p) => {
          if (!p) return;
          const vm = Number(p.vm);
          if (isNaN(vm)) return;
          [p.carga, p.desc].forEach((x) => {
            if (x == null || x === '' || isNaN(Number(x))) return;
            const e = Math.abs(Number(x) - vm);
            if (maior == null || e > maior) maior = e;
          });
        });
        if (!isNaN(cls) && mi != null && ma2 != null && maior != null) {
          const tol = (cls / 100) * (Number(ma2) - Number(mi));
          return maior <= tol ? 'APROVADO' : 'REPROVADO';
        }
        return 'APROVADO';
      } },
    { n: 'fator_k', l: 'Fator k', t: 'sel', span: 4, o: [[2, '2 (95%)'], [3, '3 (99%)']],
      ajuda: 'Multiplicador da incerteza padrão para chegar na incerteza expandida. k = 2 corresponde a cerca de 95% de confiança.' },
    { n: 'calibracao_vacuo', l: 'Calibração em vácuo?', t: 'bool', span: 5,
      ajuda: 'Marque quando a calibração for na faixa de vácuo. O laudo passa a usar a incerteza de vácuo do padrão, que é menor que a de pressão.' },
    { n: 'danificado', l: 'Danificado?', t: 'bool', span: 4, ajuda: 'Marque se o manômetro chegou com dano que impeça o uso.' },
    { n: 'substituido', l: 'Substituído?', t: 'bool', span: 4, ajuda: 'Marque se o manômetro foi trocado por outro no atendimento.' }
  ]
};

export default manometro;
